import React, { useState } from 'react'
import { CharacterCreationWizard } from './CharacterCreationWizard'

/**
 * Empty-state landing shown when the asset-manager has ZERO characters.
 *
 * This is the "fresh install / new database" state — analogous to Unreal's
 * Project Browser when you have no project. It is deliberately NOT the error
 * overlay: an empty character list is a successful, valid server response, not
 * a failure (see src/lib/characterState.js and docs/UX_PRINCIPLES.md).
 *
 * Props:
 *   onCreated(config) — called with the new character config after the wizard
 *     completes. The parent switches to it (clears the empty state).
 */
export default function NoCharactersScreen({ onCreated }) {
  const [showWizard, setShowWizard] = useState(false)

  return (
    <div
      style={{
        width: '100%', height: '100%', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a0a0f', color: '#cde0ff',
        fontFamily: 'var(--m-font)', padding: 32, textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>🎭</div>
        <div style={{ fontSize: 18, marginBottom: 8, color: '#e8f0ff' }}>No characters yet</div>
        <div style={{ color: '#8a93a8', fontSize: 13, marginBottom: 24, lineHeight: 1.5 }}>
          This asset-manager has no characters. Create one to get started.
        </div>
        <button
          onClick={() => setShowWizard(true)}
          style={{
            background: '#1d2b4a', color: '#cde0ff', border: '1px solid #2f4d86',
            borderRadius: 6, padding: '10px 20px', fontFamily: 'var(--m-font)',
            fontSize: 14, cursor: 'pointer',
          }}
        >
          + Create Character
        </button>
      </div>

      {showWizard && (
        <CharacterCreationWizard
          onCreated={config => { setShowWizard(false); onCreated?.(config) }}
          onCancel={() => setShowWizard(false)}
        />
      )}
    </div>
  )
}
